export function convertInlineVideoEntry(videoEntry) {
  const videoAdContext = {
    sponsorTitle: videoEntry.metadata('sponsorTitle').value(),
  };
  videoAdContext.type = 'Youtube';
  videoAdContext.videoId = videoEntry.metadata('youtube-videoid').value();
  videoAdContext.playlistId = '';

  return {
    id: 'inline-video-ad',
    videoAdContext,
  };
}

/**
 * Pure func to retrieve random articles from more-in research categories editorial section
 * @param {string} canonicalURL
 * @param {[]} moreInCategories
 * @param {boolean} omitDate
 * @param {number} numberOfLinks
 */
export function getMoreInCategoriesLinks(canonicalURL, moreInCategories, omitDate = false, numberOfLinks = 5) {
  return moreInCategories
    .filter(moreInCategory => {
      const title = moreInCategory.metadata('title').value();
      const url = moreInCategory.metadata('url').value();

      // Remove links without title and the the link to the page with links itself
      return title && !RegExp(`${url}$`).test(canonicalURL);
    })
    .slice(0, numberOfLinks)
    .map(moreInCategory => ({
      name: moreInCategory.metadata('title').value(),
      href: moreInCategory.metadata('url').value(),
      date: omitDate ? undefined : moreInCategory.metadata('publishDate').value(),
      relatedTitle: moreInCategory.metadata('relatedTitle').value(),
      sponsorTitle: moreInCategory.metadata('sponsorTitle').value(),
    }));
}
